import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Bar } from 'vue-chartjs';
let chart = class chart extends Vue {
    watchChartData() { this.updateData(); }
    watchOhartData() { this.updateData(); }
    //hook mounted
    mounted() {
        const that = this; // workaround for this.renderChart ???
        // const inst = this.$data
        // this.$data._plugins.push({
        //   id: 'text-on-bars',
        //   afterDraw(chart: any) {
        //       var ctx = chart.ctx;
        //       ctx.textAlign = 'center';
        //       ctx.fillStyle = "rgba(255, 255, 255, 1)";
        //       ctx.textBaseline = 'bottom';
        //       console
        //       // inst.datasets.forEach(function (dataset:any, i:any) {
        //       //     var meta = chart.controller.getDatasetMeta(i);
        //       //     meta.data.forEach(function (bar:any, index:any) {
        //       //         var data = Math.round(dataset.data[index]);
        //       //         ctx.fillText(data, bar._model.x, bar._model.y - 115);
        //       //     });
        //       // });
        //   }
        // })
        that.renderChart(this.chartData, this.options);
    }
    updateData() {
        let chart = this.$data._chart;
        if (chart) {
            chart.destroy();
            this.$emit('chart:destroy');
        }
        this.renderChart(this.chartData, this.options);
        this.$emit('chart:render');
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "chartData", void 0);
tslib_1.__decorate([
    Prop({ required: true })
], chart.prototype, "options", void 0);
tslib_1.__decorate([
    Watch('chartData')
], chart.prototype, "watchChartData", null);
tslib_1.__decorate([
    Watch('options')
], chart.prototype, "watchOhartData", null);
chart = tslib_1.__decorate([
    Component({ extends: Bar })
], chart);
export default chart;
